import dayjs from "dayjs";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import { RsvpEventDetails } from "queries/rsvp.queries";
import React from "react";
import { Text, View } from "react-native";
import { useRsvpColors } from "../theme";

interface Props {
  event: RsvpEventDetails;
  // Hide the date line (e.g. on the general page, where multiple
  // same-named events may share the slug and dates would be ambiguous)
  showDate?: boolean;
}

/** Centered event hero: venue eyebrow + name + date. */
const RsvpEventHeader: React.FC<Props> = ({ event, showDate = true }) => {
  const { data: tenantConfiguration } = useFetchTenantConfigurationQuery();
  const colors = useRsvpColors();
  const venue = event.venueName;

  return (
    <View style={{ alignItems: "center", marginBottom: 32 }}>
      {venue ? (
        <Text
          style={{
            color: colors.textMuted,
            fontSize: 12,
            textTransform: "uppercase",
            letterSpacing: 2,
            marginBottom: 4,
          }}
        >
          {venue}
        </Text>
      ) : null}
      <Text
        style={{
          color: colors.textPrimary,
          fontSize: 30,
          fontWeight: "700",
          textAlign: "center",
          marginBottom: 8,
        }}
      >
        {event.eventName}
      </Text>
      {showDate ? (
        <Text
          style={{
            color: colors.textSecondary,
            fontSize: 18,
            textAlign: "center",
          }}
        >
          {dayjs(event.eventDate)
            .tz(tenantConfiguration?.timezone)
            .format("dddd, MMMM D, YYYY · h:mm A")}
        </Text>
      ) : null}
    </View>
  );
};

export default RsvpEventHeader;
